import { mixed, number, object, string } from 'yup';
import { generateNamesObject } from '../../utils';
import { FormValues, getInitialFormValues } from '../../utils/formUtils';
import { TrailingStopType } from '../TradingForm';

export const fieldNames = generateNamesObject(
    'orderRef',
    'quantity',
    'stopPrice',
    'limitPrice',
    'value',
    'pegType',
    'pegDifference',
);

export const modifyOrderSchema = object({
    [fieldNames.orderRef]: string().required(),
    [fieldNames.quantity]: number().label('Quantity'),
    [fieldNames.stopPrice]: number().label('Stop Price'),
    [fieldNames.limitPrice]: number().label('Limit Price'),
    [fieldNames.value]: number().label('Value'),
    [fieldNames.pegType]: mixed<TrailingStopType>().label('Peg Type'),
    [fieldNames.pegDifference]: number().label('Peg Difference'),
});

export type ModifyOrderFormValues = FormValues<typeof modifyOrderSchema>;

export const getInitialModifyOrderFormValues = (values?: Partial<ModifyOrderFormValues>) =>
    getInitialFormValues(modifyOrderSchema, values);
